var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRiskAnalytics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "21px",
    viewBox: "0 0 25 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Atoms",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2705-icons/apps/risk-analytics",
    transform: "translate(1.000000, -1.000000)",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "risk",
    transform: "translate(0.500000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.120133,19.1122559 C21.9123258,17.0843142 23,14.4191771 23,11.5 C23,5.14872538 17.8512746,0 11.5,0 C5.14872538,0 0,5.14872538 0,11.5 C0,14.5798616 1.21071061,17.3769466 3.18215787,19.441281",
    id: "Path",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 2.5,
    id: "Path",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.43933983,
    y1: 3.43933983,
    x2: 5.20710678,
    y2: 5.20710678,
    id: "Path-Copy-3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    points: "16.0014452 15.0640702 16.1499842 14.9316282 11.5 9.7206405 10.7771036 10.4785553"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.439339828,
    y1: 10.4393398,
    x2: 2.20710678,
    y2: 12.2071068,
    id: "Path-Copy-5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(1.323223, 11.323223) rotate(-45.000000) translate(-1.323223, -11.323223) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.4393398,
    y1: 3.43933983,
    x2: 19.2071068,
    y2: 5.20710678,
    id: "Path-Copy-4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(18.323223, 4.323223) scale(-1, 1) translate(-18.323223, -4.323223) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.43933983,
    y1: 17.4393398,
    x2: 5,
    y2: 19.2071068,
    id: "Path-Copy-7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(4.219670, 18.323223) scale(1, -1) translate(-4.219670, -18.323223) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.4393398,
    y1: 17.4393398,
    x2: 20,
    y2: 19.2071068,
    id: "Path-Copy-8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(19.219670, 18.323223) scale(-1, -1) translate(-19.219670, -18.323223) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.4393398,
    y1: 10.4393398,
    x2: 22.2071068,
    y2: 12.2071068,
    id: "Path-Copy-6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(21.323223, 11.323223) rotate(-45.000000) translate(-21.323223, -11.323223) "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskAnalytics);
export default __webpack_public_path__ + "static/media/risk-analytics.0237a83a.svg";
export { ForwardRef as ReactComponent };